import { Controller } from 'stimulus'
// import _ from 'underscore'

export default class extends Controller {
  menuFixed() {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    const num = 60

    if (scrollTop < num) {
      this.element.classList.remove('-fixed')
    } else {
      this.element.classList.add('-fixed')
    }
  }
}
